/**
 * Maps build identity (`environment.name`) × colour scheme to the PWA manifest that carries the
 * correct per-environment icon set. Kept pure and exported so it can be unit-tested without
 * instantiating ThemeService (which depends on DOCUMENT/Platform).
 *
 * Icon sets by manifest: dev/* (yellow), prod/* (orange on white), local/* (orange on black).
 * The apple-touch-icon (iOS home-screen) is NOT set here — iOS resolves it from the static
 * <head> at add-to-home-screen time, so it is baked in per build (see apply-build-branding.mjs).
 */
export type ManifestBuildName = 'development' | 'production' | 'local';

const MANIFEST_BY_BUILD: Record<ManifestBuildName, { light: string; dark: string }> = {
  development: { light: 'manifest.dev.json', dark: 'manifest.dev.dark.json' },
  production: { light: 'manifest.prod.json', dark: 'manifest.prod.dark.json' },
  local: { light: 'manifest.json', dark: 'manifest.dark.json' },
};

export function resolveManifestPath(buildName: string, isDark: boolean): string {
  const set: { light: string; dark: string } =
    MANIFEST_BY_BUILD[buildName as ManifestBuildName] ?? MANIFEST_BY_BUILD.local;
  return isDark ? set.dark : set.light;
}
